// Interface
import { Item } from '../interface'

type State =
 | { status: 'empty' }
 | { status: 'loading' }
 | { status: 'error', error: string }
 | { status: 'success', data: Item }

type Action =
| { type: 'request' }
| { type: 'success', results: Item }
| { type: 'failure', error: string }

export default function quizReducer(state: State, action: Action): State {
	switch (action.type) {
	case 'request':
		return { status: 'loading' }
	case 'success':
		return { status: 'success', data: action.results }
	case 'failure':
		return { status: 'error', error: action.error }
	}
}
